import React, { useEffect, useRef, useState } from 'react'
import FormCreator from '../../../../../components/forms/FormCreator'
import { EditPricingData } from '../data/PricingDetails.Data';
import Buttons from '../../../../../components/ui/button/Buttons';
import { object } from 'prop-types';

const EditPricingDetail = ({ editPricingData, handleEditPricingDetails, }) => {
    const [editPricingFormData, setEditPricingFormData] = useState(EditPricingData);
    const editPricingRef = useRef();

    const handleOk = () => {
        const formData = editPricingRef?.current?.getFormData();
        console.log({ formData })
        if (!formData) return;
        handleEditPricingDetails(formData)
    }

    useEffect(() => {
        if (Object.keys(editPricingData).length > 0) {
            setEditPricingFormData({ ...editPricingFormData, initialState: { ...editPricingFormData.initialState, ...editPricingData } })
        }
    }, [editPricingData])
    return (
        <div>
            <FormCreator
                config={editPricingFormData}
                ref={editPricingRef}
                key={false}
            //   onColumnChange={handleColumnChange}
            //   onFieldBlure={handleFieldBlureChange}
            />
            <Buttons
                onClick={handleOk}
                buttonTypeClassName="btn theme-btn my-2"
                buttonText={"Ok"}
            />
        </div>
    )
}

export default EditPricingDetail
